import { Plugin, PluginKey } from 'prosemirror-state'
import { decorations } from 'common/Prose/Plugins/StreamDocContent/decorations'
import { createRoot, Root } from 'react-dom/client'

export const StreamDocContentPluginKey = new PluginKey('StreamDocContent')

export enum StreamDocContentStatus {
  'idle' = 'idle',
  'streaming' = 'streaming',
}

export type StreamDocContentPluginState = { container: HTMLDivElement; root: Root } & (
  | { status: StreamDocContentStatus.idle }
  | {
      status: StreamDocContentStatus.streaming
      jobId: string
      selection: { [key: string]: any } | undefined | null
      mode: string
      uuid: string | undefined | null
    }
)
export type StreamDocContentPluginMeta =
  | {
      action: 'start'
      jobId: string
      selection: { [key: string]: any } | undefined | null
      mode: string
      uuid: string | undefined | null
    }
  | {
      action: 'done'
    }

export const StreamDocContentPlugin = new Plugin({
  key: StreamDocContentPluginKey,
  state: {
    init: (): StreamDocContentPluginState => {
      const container = document.createElement('div')
      const root = createRoot(container)
      return {
        status: StreamDocContentStatus.idle,
        container,
        root,
      }
    },
    apply: (tr, pluginState: StreamDocContentPluginState): StreamDocContentPluginState => {
      const pluginMeta: StreamDocContentPluginMeta = tr.getMeta(StreamDocContentPluginKey)

      if (pluginMeta) {
        switch (pluginMeta.action) {
          case 'start': {
            return {
              ...pluginState,
              status: StreamDocContentStatus.streaming,
              jobId: pluginMeta.jobId,
              selection: pluginMeta.selection,
              mode: pluginMeta.mode,
              uuid: pluginMeta.uuid,
            }
          }
          case 'done': {
            const container = document.createElement('div')
            const root = createRoot(container)
            return { status: StreamDocContentStatus.idle, container, root }
          }
        }
      }
      return { ...pluginState }
    },
  },
  props: {
    decorations: decorations,
  },
})
